<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="profit-loss-drill-through-main">
    <div class="drill-through-body">
      <TableBox
        :title="tableTitle"
        :tableData.sync="drillThroughTableData"
        :maxSelection="0"
        :hideColumns="hideColumns"
        :loading="drillThroughTableLoading"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      tableTitle: '',
      drillThroughTableData: [],
      hideColumns: [],
      drillThroughTableLoading: false,
    };
  },
  props: {},
  methods: {
    getTableData: async function (requestBody) {
      this.$fullscreenLoading(`Getting ${requestBody.rpttype.includes('TXN') ? 'Transaction' : 'Details'}`);
      requestBody['incldatatype'] = '1';
      const response = await this.$apiCallV2('/HQConsolidatedProfitLoss/GetPNLAnalysis', requestBody);
      if (!response || response.length === 0) {
        this.$fullscreenLoading();
        return;
      }
      let formattedData = [];
      if (requestBody.rpttype.includes('DETAILS')) {
        const start = new Date(requestBody['startdate']).formatString('dd/MM/yy');
        const end = new Date(requestBody['enddate']).formatString('dd/MM/yy');
        const dateRangeKey = `${start}-${end}`;
        this.hideColumns = [dateRangeKey, 'Operation', '#', 'PNLSeq'];

        formattedData = response.map((item) => {
          return {
            'GL Account No.': item['Operation'],
            Description: item[dateRangeKey],
            ...item,
          };
        });
      } else if (requestBody.rpttype.includes('TXN')) {
        this.hideColumns = ['#'];
        formattedData = response.map((item) => {
          return {
            '#': item['#'], //add it in so that table will auto set the datatype
            'Branch-Department': item['Br-Dept'],
            'Txn Date': item['Txn Date'],
            'Txn Type': item['Txn'],
            'Ref #': item['Ref #'],
            'Cheque/AP Invoice #': item['Cheque/APInv #'],
            'Debtor Code': item['debtor'],
            'Debtor Name': item['debtorname'],
            'Creditor Code': item['creditor'],
            'Creditor Name': item['creditorname'],
            'Debit Ac.': item['Dr'],
            'Credit Ac': item['Cr'],
            Amount: item['Amount'],
            'Batch #': item['Batch #'],
            'Debit Subgroup': item['Dr Subgroup'],
            'Debit Report': item['Dr Rpt'],
            'Credit Subgroup': item['Cr Subgroup'],
            'Credit Report': item['Cr Rpt'],
          };
        });
      }

      this.$fullscreenLoading();
      this.$nextTick(() => {
        this.drillThroughTableData = formattedData || response;
      });
    },
  },
  async mounted() {
    const details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName + '_HQPNL'));

    const drillThroughType = this.$route.params.drillThroughName.match(/\(([^)]+)\)/)[1];
    const drillThroughItem = details.series;

    this.tableTitle = `${drillThroughItem ? drillThroughItem + ' - ' : ''}${drillThroughType}`;

    this.drillThroughTableLoading = true;
    await this.getTableData(details.data);
    this.drillThroughTableLoading = false;
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.profit-loss-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>
